import {
  useClientKeysStore,
  useDeploymentsStore,
  useEstatesStore,
  useLedgerStore,
  useMemoriesStore,
  useMemoryTenantsStore,
  usePoolStore,
  useTenantKeysStore,
  useTenantsStore,
  useTokensStore,
} from './dataStores';
import { useAnalyticsStore } from './analyticsStore';
import { useUIStore } from './uiStore';

/* Sign-out is the one moment "never blank the data" does not apply.
 *
 * Everything the previous identity could see goes: rows, charts, the open
 * drawer, the tenant scope. Leaving a table populated after the credential that
 * fetched it is gone would be showing one operator another's view. */
export function resetAllData(): void {
  useEstatesStore.getState().reset();
  useDeploymentsStore.getState().reset();
  useTokensStore.getState().reset();
  useClientKeysStore.getState().reset();
  useLedgerStore.getState().reset();
  usePoolStore.getState().reset();
  useTenantKeysStore.getState().reset();
  useMemoriesStore.getState().reset();
  useMemoryTenantsStore.getState().reset();
  useTenantsStore.getState().reset();
  useAnalyticsStore.getState().reset();
  useUIStore.getState().reset();
}
